import { z } from "zod";
import { absenceCategories } from "../../../absences";

export const getOrganizationAbsencesQuerySchema = z.object({
	startDate: z.string().optional(),
	endDate: z.string().optional(),
	state: z.enum(["pending", "approved", "rejected", "cancelled"]).optional(),
	category: z.enum(absenceCategories).optional(),
	teamId: z.uuid().optional(),
});

export type GetOrganizationAbsencesQuerySchema = z.infer<typeof getOrganizationAbsencesQuerySchema>;
